import React from 'react';

// Containers
import ContentContainer from './ContentContainer';

const App = (props) => {
    return (
        <div className="test-drive-container">
            <ContentContainer store={props.store} />
        </div>
  )
};

export default App;
